import React from "react";
import { Route } from "react-router-dom";
import { IRoutes, routes } from "../router/index";
import styles from "./Main.module.scss";

export default function Main() {
  return (
    <div className={styles.page}>
      {routes.map((route: IRoutes) => (
        <Route
          key={route.name}
          exact={route.exact}
          path={route.path}
          component={route.component}
        />
      ))}
    </div>
  );
}
